/**
 * Sticky homepage promo bar — close behaviour only.
 *
 * Close hides the bar for the current page view only; state is NOT persisted,
 * so a reload brings the bar back (per spec). No storage, no cookie.
 *
 * Markup contract — sections/homepage-promo-bar.liquid:
 *   [data-promo-bar]              the bar
 *     [data-promo-close]          close <button>
 */
export default function initPromoBar() {
  document.querySelectorAll('[data-promo-bar]').forEach((bar) => {
    const close = bar.querySelector('[data-promo-close]');
    if (!close) return;
    close.addEventListener('click', () => {
      bar.setAttribute('hidden', '');
    });
  });
}
